(function () {
  if (window.sdWaitForVolumnDiscounts) return;

  let resolve;
  const promise = new Promise(r => (resolve = r));
  window.sdWaitForVolumnDiscounts = () => promise;
  let _tlDiscounts;

  Object.defineProperty(window, "tlDiscounts", {
    configurable: true,
    get() {
      return _tlDiscounts;
    },
    set(obj) {
      if (!obj || obj.__hooked) {
        _tlDiscounts = obj;
        return;
      }

      obj.__hooked = true;
      _tlDiscounts = obj;

      let _internalGroup = obj.discountsGroup;

      Object.defineProperty(obj, "discountsGroup", {
        configurable: true,
        get() {
          return _internalGroup;
        },
        set(v) {
          _internalGroup = v;

          resolve({
            group: v,
            chooseDefaultDeal: obj.chooseDefaultDeal
          });
        }
      });
    }
  });
})();